import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiShield } from 'react-icons/fi';
import '../styles/CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <FiShield className="cookie-icon" />
          <p>
            We use cookies to improve your experience. 
            <Link to="/privacy"> Learn more</Link>
          </p>
        </div>
      </div>
      
      <div className="cookie-buttons">
        <button onClick={declineCookies} className="decline-button">
          Decline
        </button>
        <button onClick={acceptCookies} className="accept-button">
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent; 